import React from 'react';

const Card = ({ children, title, className = '' }) => (
  <div className={`bg-white shadow-lg rounded-xl overflow-hidden m-4 ${className}`}>
    {title && <h2 className="text-2xl font-bold p-6 bg-gray-50 border-b">{title}</h2>}
    <div className="p-6">{children}</div>
  </div>
);

export default Card;
